import { zhaliePanels, wudaoPanels, shenyePanels, jinjiPanels } from './panels';

export interface Comic {
  id: string;
  title: string;
  categories: string[];
  author: string;
  status: '连载中' | '已完结';
  rating: number;
  views: string;
  favorites: string;
  chapters: number;
  latestChapter: string;
  updatedAt: string;
  year: number;
  tags: string[];
  description: string;
  cover: string;
  panels?: string[];
  isHot?: boolean;
  isNew?: boolean;
  isRecommended?: boolean;
  isCompleted?: boolean;
  isFeatured?: boolean;
}

export const comics: Comic[] = [
  {
    id: 'zhalie-ba-jubang',
    title: '炸裂吧！巨棒',
    categories: ['hanman', 'rexue'],
    author: '金炸裂工作室',
    status: '连载中',
    rating: 9.8,
    views: '2587万',
    favorites: '186万',
    chapters: 128,
    latestChapter: '第128话 觉醒风暴前夜',
    updatedAt: '今天 09:12',
    year: 2024,
    tags: ['韩漫', '热血', '超能力', '逆袭', '无删减'],
    description:
      '平凡高中生棒槌偶然捡到一枚神秘橙色晶石，体内沉睡的"炸裂之力"彻底觉醒！从此，他将在危机四伏的都市异能世界中，用一拳接一拳的爆炸冲击，炸出一条属于自己的强者之路。下拉式免费阅读，无删减韩漫高清呈现。',
    cover:
      "https://readdy.ai/api/search-image?query=Dynamic%20Korean%20manhwa%20cover%20illustration%20of%20a%20fierce%20young%20hero%20with%20spiky%20dark%20hair%20clenching%20his%20fist%2C%20explosive%20orange%20shockwave%20energy%20rings%20bursting%20from%20his%20body%2C%20cracked%20street%20ground%2C%20glowing%20ember%20particles%20floating%2C%20bold%20clean%20linework%2C%20dramatic%20rim%20lighting%2C%20vibrant%20orange%20and%20warm%20amber%20color%20grading%2C%20clean%20minimal%20background%20with%20soft%20warm%20gradient%20tones%20and%20subtle%20radial%20explosion%20glow%2C%20high%20quality%20digital%20painting%2C%20epic%20comic%20composition%2C%20no%20text%2C%20no%20watermark&width=600&height=800&seq=cover-zhalie-jubang-01&orientation=portrait",
    panels: zhaliePanels,
    isHot: true,
    isNew: true,
    isRecommended: true,
    isFeatured: true,
  },
  {
    id: 'wudao-qiankun',
    title: '武道乾坤',
    categories: ['rexue', 'xuanhuan'],
    author: '苍梧客',
    status: '连载中',
    rating: 9.5,
    views: '1934万',
    favorites: '132万',
    chapters: 356,
    latestChapter: '第356话 问鼎天骄榜',
    updatedAt: '今天 08:40',
    year: 2022,
    tags: ['热血', '武学', '宗门', '逆袭'],
    description:
      '少年叶尘出身卑微，却身怀武道不灭之魂。他以拳问天、以气破局，在宗门林立、天骄辈出的乱世中一路逆流而上，只为守护心中那片武道乾坤。国风热血武侠漫画，下拉式阅读更过瘾。',
    cover:
      "https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20illustration%20of%20a%20determined%20martial%20artist%20in%20flowing%20ancient%20robes%20with%20long%20black%20hair%2C%20golden%20energy%20aura%20swirling%20around%20his%20body%2C%20mountain%20temple%20silhouettes%20in%20the%20background%2C%20bold%20clean%20linework%2C%20dramatic%20lighting%2C%20vibrant%20warm%20amber%20and%20orange%20color%20grading%2C%20clean%20minimal%20background%20with%20soft%20warm%20gradient%20tones%20and%20golden%20mist%2C%20high%20quality%20digital%20painting%2C%20epic%20comic%20composition%2C%20no%20text%2C%20no%20watermark&width=600&height=800&seq=cover-wudao-qiankun-01&orientation=portrait",
    panels: wudaoPanels,
    isHot: true,
    isRecommended: true,
  },
  {
    id: 'shenye-shenxun',
    title: '深夜审讯室',
    categories: ['xuanyi', 'dushi'],
    author: '墨白',
    status: '连载中',
    rating: 9.6,
    views: '1542万',
    favorites: '98万',
    chapters: 214,
    latestChapter: '第214话 雨夜来客',
    updatedAt: '今天 07:55',
    year: 2023,
    tags: ['悬疑', '推理', '都市', '烧脑'],
    description:
      '凌晨三点的审讯室，总会有不速之客光临。刑警老周与年轻搭档在一桩桩离奇案件中抽丝剥茧，却发现每一桩谜案背后，都指向一个深不可测的真相。烧脑悬疑漫画佳作，反转接反转让人欲罢不能。',
    cover:
      "https://readdy.ai/api/search-image?query=Korean%20manhwa%20suspense%20cover%20illustration%20of%20a%20mysterious%20detective%20in%20a%20long%20trench%20coat%20standing%20in%20a%20dark%20interrogation%20room%2C%20single%20warm%20desk%20lamp%20casting%20dramatic%20shadows%2C%20smoke%20and%20dust%20particles%20in%20the%20light%20beam%2C%20bold%20clean%20linework%2C%20moody%20cinematic%20lighting%2C%20warm%20orange%20highlights%20against%20deep%20shadows%2C%20clean%20minimal%20background%20of%20a%20dark%20room%20with%20warm%20gradient%2C%20high%20quality%20digital%20painting%2C%20noir%20comic%20composition%2C%20no%20text%2C%20no%20watermark&width=600&height=800&seq=cover-shenye-shenxun-01&orientation=portrait",
    panels: shenyePanels,
    isHot: true,
    isRecommended: true,
  },
  {
    id: 'jinji-zhi-lian',
    title: '禁忌之恋',
    categories: ['hanman', 'lianai'],
    author: '姜糖',
    status: '连载中',
    rating: 9.4,
    views: '2210万',
    favorites: '167万',
    chapters: 96,
    latestChapter: '第96话 心动余温',
    updatedAt: '昨天 23:20',
    year: 2024,
    tags: ['韩漫', '恋爱', '情感', '甜虐'],
    description:
      '一段不被看好的爱情，两个拼命靠近的灵魂。在世俗眼光与家族压力之间，他们每一次心动都像踩在钢丝上。韩漫恋爱大作，细腻画风与真实情感描绘让人共情爆棚，下拉式免费阅读全程高甜高虐。',
    cover:
      "https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20illustration%20of%20a%20dramatic%20romantic%20scene%20between%20two%20elegant%20characters%20reaching%20toward%20each%20other%2C%20rose%20petals%20floating%2C%20deep%20warm%20crimson%20and%20amber%20tones%2C%20intense%20emotional%20expressions%2C%20bold%20clean%20linework%2C%20cinematic%20lighting%20with%20soft%20glow%2C%20clean%20minimal%20background%20with%20warm%20gradient%20and%20floating%20petals%2C%20high%20quality%20digital%20painting%2C%20emotional%20comic%20composition%2C%20no%20text%2C%20no%20watermark&width=600&height=800&seq=cover-jinji-zhi-lian-01&orientation=portrait",
    panels: jinjiPanels,
    isHot: true,
    isNew: true,
    isRecommended: true,
  },
  {
    id: 'dushi-yixian',
    title: '都市医仙',
    categories: ['dushi', 'xuanhuan'],
    author: '南巷清风',
    status: '连载中',
    rating: 9.2,
    views: '1765万',
    favorites: '121万',
    chapters: 462,
    latestChapter: '第462话 妙手仁心',
    updatedAt: '昨天 22:10',
    year: 2021,
    tags: ['都市', '神医', '扮猪吃虎', '爽文'],
    description:
      '一代医仙重生都市，从被人轻视的实习医生做起，以一手神鬼莫测的针法与炼丹术纵横都市。悬壶济世也好，快意恩仇也罢，这一世他绝不再低调。都市爽文改编漫画，更新稳定看得过瘾。',
    cover:
      "https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20illustration%20of%20a%20calm%20confident%20young%20doctor%20in%20a%20modern%20white%20coat%20holding%20a%20needle%2C%20hands%20glowing%20with%20golden%20healing%20energy%2C%20modern%20city%20skyline%20blurred%20in%20the%20background%2C%20soft%20warm%20sunset%20tones%2C%20bold%20clean%20linework%2C%20dramatic%20cinematic%20lighting%2C%20vibrant%20warm%20color%20grading%2C%20clean%20minimal%20background%20with%20soft%20warm%20gradient%20and%20glowing%20light%20particles%2C%20high%20quality%20digital%20painting%2C%20comic%20composition%2C%20no%20text%2C%20no%20watermark&width=600&height=800&seq=cover-dushi-yixian-01&orientation=portrait",
    isHot: true,
  },
  {
    id: 'luohua-fengjun',
    title: '落花时节又逢君',
    categories: ['lianai', 'dushi'],
    author: '三月桃花',
    status: '已完结',
    rating: 9.3,
    views: '989万',
    favorites: '76万',
    chapters: 188,
    latestChapter: '完结篇 花落花开',
    updatedAt: '07-28 20:15',
    year: 2023,
    tags: ['恋爱', '治愈', '青春', '完结'],
    description:
      '青春里错过的花，终于在成年后的那个春天重新盛开。多年后重逢的两人，在熟悉又陌生的城市里，慢慢找回当年没说出口的心意。清新治愈系恋爱漫画，完结精品值得一口气看完。',
    cover:
      "https://readdy.ai/api/search-image?query=Korean%20manhwa%20romance%20cover%20illustration%20of%20a%20gentle%20young%20couple%20standing%20under%20a%20blooming%20cherry%20blossom%20tree%2C%20pink%20and%20white%20petals%20falling%2C%20soft%20warm%20afternoon%20sunlight%2C%20tender%20expressions%2C%20bold%20clean%20linework%2C%20romantic%20warm%20color%20grading%20with%20soft%20blush%20tones%2C%20clean%20minimal%20background%20of%20pastel%20sky%20and%20falling%20petals%2C%20high%20quality%20digital%20painting%2C%20dreamy%20comic%20composition%2C%20no%20text%2C%20no%20watermark&width=600&height=800&seq=cover-luohua-fengjun-01&orientation=portrait",
    isCompleted: true,
    isRecommended: true,
  },
  {
    id: 'chaoneng-shaoniantuan',
    title: '超能少年团',
    categories: ['rexue', 'dushi'],
    author: '闪电队长',
    status: '连载中',
    rating: 9.1,
    views: '1348万',
    favorites: '88万',
    chapters: 240,
    latestChapter: '第240话 城市保卫战',
    updatedAt: '昨天 21:30',
    year: 2022,
    tags: ['热血', '超能力', '团队', '青春'],
    description:
      '五个性格迥异的高中生意外获得超能力，组成了守护城市的"超能少年团"。战斗、友情、成长与搞笑的日常交织，燃到炸裂的团战场面令人热血沸腾！',
    cover:
      "https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20illustration%20of%20a%20group%20of%20five%20energetic%20teenage%20superheroes%20in%20cool%20streetwear%20posing%20together%20with%20colorful%20energy%20auras%20in%20orange%20and%20gold%2C%20urban%20rooftop%20background%20at%20sunset%2C%20bold%20clean%20linework%2C%20vibrant%20warm%20color%20grading%2C%20dramatic%20lighting%2C%20clean%20minimal%20background%20with%20soft%20warm%20gradient%20sky%2C%20high%20quality%20digital%20painting%2C%20comic%20group%20composition%2C%20no%20text%2C%20no%20watermark&width=600&height=800&seq=cover-chaoneng-shaoniantuan-01&orientation=portrait",
    isHot: true,
    isNew: true,
  },
  {
    id: 'wo-shi-saodiseng',
    title: '我是扫地僧',
    categories: ['xuanhuan', 'rexue'],
    author: '扫地老僧',
    status: '连载中',
    rating: 9.0,
    views: '1120万',
    favorites: '79万',
    chapters: 178,
    latestChapter: '第178话 藏经阁风波',
    updatedAt: '昨天 19:45',
    year: 2023,
    tags: ['玄幻', '武侠', '隐藏大佬', '轻松'],
    description:
      '扫地十年无人识，一朝成名天下知。少林寺最不起眼的扫地僧，其实是隐世多年的绝顶高手。轻松幽默中带着热血，隐藏大佬扮猪吃虎的设定让人大呼过瘾。',
    cover:
      "https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20illustration%20of%20a%20humble%20bald%20monk%20in%20gray%20robes%20quietly%20sweeping%20a%20temple%20courtyard%2C%20subtle%20golden%20divine%20aura%20radiating%20behind%20him%2C%20ancient%20temple%20and%20bamboo%20silhouettes%2C%20bold%20clean%20linework%2C%20warm%20golden%20hour%20lighting%2C%20vibrant%20warm%20color%20grading%2C%20clean%20minimal%20background%20with%20soft%20warm%20gradient%20and%20floating%20dust%20particles%2C%20high%20quality%20digital%20painting%2C%20zen%20comic%20composition%2C%20no%20text%2C%20no%20watermark&width=600&height=800&seq=cover-wo-shi-saodiseng-01&orientation=portrait",
    isRecommended: true,
  },
  {
    id: 'zuqiang-baobiao',
    title: '都市之最强保镖',
    categories: ['dushi', 'rexue'],
    author: '铁血书生',
    status: '连载中',
    rating: 8.9,
    views: '1421万',
    favorites: '95万',
    chapters: 520,
    latestChapter: '第520话 千金归心',
    updatedAt: '昨天 18:00',
    year: 2020,
    tags: ['都市', '保镖', '逆袭', '爽文'],
    description:
      '退役特种兵林锋回归都市，成了刁蛮千金的贴身保镖。当一个个隐藏势力接连登场，他一次次用实力证明：这个保镖，不简单！都市爽文经典之作，剧情紧凑停不下来。',
    cover:
      "https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20illustration%20of%20a%20confident%20muscular%20bodyguard%20in%20a%20sharp%20black%20suit%20and%20sunglasses%20with%20arms%20crossed%2C%20luxury%20city%20street%20at%20dusk%20behind%20him%2C%20warm%20neon%20amber%20glow%2C%20bold%20clean%20linework%2C%20dramatic%20cinematic%20lighting%2C%20vibrant%20warm%20color%20grading%2C%20clean%20minimal%20background%20with%20soft%20warm%20gradient%20and%20bokeh%20lights%2C%20high%20quality%20digital%20painting%2C%20action%20comic%20composition%2C%20no%20text%2C%20no%20watermark&width=600&height=800&seq=cover-zuqiang-baobiao-01&orientation=portrait",
  },
  {
    id: 'xindong-xinhao',
    title: '心动信号',
    categories: ['lianai', 'dushi'],
    author: '蜜糖研究所',
    status: '连载中',
    rating: 9.2,
    views: '1689万',
    favorites: '143万',
    chapters: 120,
    latestChapter: '第120话 恋爱心动季',
    updatedAt: '昨天 16:25',
    year: 2024,
    tags: ['恋爱', '校园', '甜宠', '轻松'],
    description:
      '一场校园恋爱综艺，让性格互补的两人被命运绑定。是真心还是剧本？心动信号不会说谎。全程高甜、颜值在线，是治愈系恋爱漫画的不二之选！',
    cover:
      "https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20illustration%20of%20a%20cute%20shy%20girl%20holding%20a%20smartphone%20with%20glowing%20pink%20hearts%20floating%20around%20her%2C%20cozy%20cafe%20background%20with%20warm%20lights%2C%20soft%20blush%20pink%20and%20warm%20amber%20tones%2C%20bold%20clean%20linework%2C%20sweet%20romantic%20lighting%2C%20clean%20minimal%20background%20with%20soft%20warm%20gradient%20and%20tiny%20hearts%2C%20high%20quality%20digital%20painting%2C%20adorable%20comic%20composition%2C%20no%20text%2C%20no%20watermark&width=600&height=800&seq=cover-xindong-xinhao-01&orientation=portrait",
    isNew: true,
  },
  {
    id: 'miwu-zhentanshe',
    title: '迷雾侦探社',
    categories: ['xuanyi', 'xuanhuan'],
    author: '夜行猫',
    status: '已完结',
    rating: 9.4,
    views: '876万',
    favorites: '64万',
    chapters: 152,
    latestChapter: '完结篇 真相大白',
    updatedAt: '06-30 15:00',
    year: 2022,
    tags: ['悬疑', '灵异', '推理', '完结'],
    description:
      '一间开在迷雾街角的侦探社，专门接手科学无法解释的怪案。社长的直觉加上社员的脑洞，让一个个诡异谜团水落石出。悬疑与灵异融合的推理佳作，结局反转精彩！',
    cover:
      "https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20illustration%20of%20a%20young%20detective%20holding%20a%20magnifying%20glass%20standing%20in%20front%20of%20a%20mysterious%20vintage%20detective%20agency%2C%20dense%20fog%20and%20warm%20lantern%20light%2C%20bold%20clean%20linework%2C%20mysterious%20cinematic%20lighting%20with%20warm%20amber%20glow%2C%20clean%20minimal%20background%20of%20a%20foggy%20street%20with%20warm%20gradient%2C%20high%20quality%20digital%20painting%2C%20mystery%20comic%20composition%2C%20no%20text%2C%20no%20watermark&width=600&height=800&seq=cover-miwu-zhentanshe-01&orientation=portrait",
    isCompleted: true,
  },
  {
    id: 'fentian-jue',
    title: '焚天诀',
    categories: ['xuanhuan', 'rexue'],
    author: '烈阳君',
    status: '已完结',
    rating: 9.1,
    views: '1204万',
    favorites: '91万',
    chapters: 300,
    latestChapter: '完结篇 焚天证道',
    updatedAt: '06-15 12:40',
    year: 2021,
    tags: ['玄幻', '热血', '修炼', '完结'],
    description:
      '天地为炉，万物为柴，我有一诀可焚天。少年炎霄觉醒上古焚天诀，在火修没落的时代里逆天而行，最终证道成尊。宏大世界观与燃爆打斗，玄幻漫画必读经典！',
    cover:
      "https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20illustration%20of%20a%20powerful%20cultivator%20surrounded%20by%20swirling%20crimson%20flames%2C%20blazing%20sky%20with%20clouds%20burning%20orange%2C%20floating%20fire%20phoenix%20silhouette%2C%20bold%20clean%20linework%2C%20dramatic%20fiery%20lighting%2C%20vibrant%20red%20and%20orange%20color%20grading%2C%20clean%20minimal%20background%20with%20warm%20ember%20gradient%20sky%2C%20high%20quality%20digital%20painting%2C%20epic%20fantasy%20comic%20composition%2C%20no%20text%2C%20no%20watermark&width=600&height=800&seq=cover-fentian-jue-01&orientation=portrait",
    isCompleted: true,
  },
];

export const getComicById = (id: string) => comics.find((c) => c.id === id);